<!-- Modal/Detalle de Comanda (mostrado cuando se selecciona una mesa) -->
<div class="flex flex-col gap-4 lg:gap-6">
  <div class="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-6">
    <!-- Panel Izquierdo: Listado de Productos -->
    <div class="rounded-2xl bg-white p-3 shadow-sm sm:p-5 lg:col-span-2">
      <div class="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h3 class="text-lg font-semibold text-slate-900">Productos</h3>
        <div class="flex flex-wrap gap-2 sm:flex-nowrap sm:items-center sm:justify-end">
          <button
            class="min-w-34 flex-1 whitespace-nowrap rounded-lg bg-blue-600 px-3 py-2.5 text-sm font-semibold text-white transition hover:bg-blue-700 sm:flex-none sm:px-4"
            (click)="modal_agregar_producto.set(true)"
            type="button"
          >
            <i class="bi bi-plus-lg mr-1" aria-hidden="true"></i>
            Agregar Producto
          </button>
          @if (
            mesa()?.comanda && mesa()?.comanda?.productos && mesa()?.comanda?.productos!.length > 0
          ) {
            <button
              class="inline-flex min-w-34 flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-linear-to-r from-sky-500 via-indigo-500 to-blue-700 px-3 py-2.5 text-sm font-semibold text-white shadow-md transition hover:shadow-lg sm:flex-none sm:px-4"
              type="button"
              aria-label="Entregar todos los productos"
              (click)="modal_confirmar_entregar_todos.set(true)"
            >
              <i class="bi bi-check2-all text-sm" aria-hidden="true"></i>
              Entregar todos
            </button>
            <button
              class="inline-flex min-w-34 flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-red-200 bg-white px-3 py-2.5 text-sm font-semibold text-red-600 transition hover:bg-red-50 sm:flex-none sm:px-4"
              type="button"
              aria-label="Limpiar productos"
              (click)="modal_confirmar_limpiar_productos.set(true)"
            >
              <i class="bi bi-eraser-fill text-sm" aria-hidden="true"></i>
              Limpiar
            </button>
          }
        </div>
      </div>

      <!-- Lista de Productos: en mobile/tablet scrollea el diálogo completo
           para evitar scroll anidado; en desktop se limita la altura. -->
      <div class="flex flex-col gap-2 lg:max-h-175 lg:overflow-y-auto lg:pr-2">
        @for (producto of mesa()?.comanda?.productos; track $index) {
          <app-comanda-card-producto
            [producto]="producto"
            [mesa_id]="$safeNavigationMigration(this.mesa()?.id)"
          />
        } @empty {
          <div class="flex flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-slate-200 py-8 text-slate-400">
            <i class="bi bi-inbox text-2xl" aria-hidden="true"></i>
            <p class="text-sm">No hay productos en la comanda.</p>
          </div>
        }
      </div>
    </div>

    <!-- Panel Derecho: Información de la Comanda -->
    <div class="lg:col-span-1">
      <div class="rounded-xl bg-white p-4 shadow-md sm:p-5 lg:sticky lg:top-4">
        <div class="mb-4 flex items-start justify-between gap-3">
          <h3 class="text-lg font-bold text-slate-900">Detalles</h3>
          <button
            type="button"
            (click)="modal_editar_mesa.set(true)"
            class="inline-flex shrink-0 items-center gap-1 rounded-lg px-2 py-1 text-sm font-medium text-blue-600 transition hover:bg-blue-50 hover:text-blue-800"
          >
            <i class="bi bi-pencil-square" aria-hidden="true"></i>
            Editar
          </button>
        </div>
        <div class="space-y-4">
          <div>
            <label class="text-xs font-semibold uppercase text-slate-500">Nombre</label>
            <p class="text-lg font-bold text-slate-900">
              {{ mesa()?.nombre }} #{{ mesa()?.numero }}
            </p>
          </div>

          <div>
            <label class="text-xs font-semibold uppercase text-slate-500">Clientes</label>
            <p class="text-lg font-bold text-slate-900">{{ mesa()?.comanda?.clientes || '—' }}</p>
          </div>

          <div>
            <label class="text-xs font-semibold uppercase text-slate-500">Estado General</label>
            <div class="mt-2">
              <span
                class="inline-flex rounded-full bg-blue-100 px-3 py-1 text-xs font-semibold text-blue-800"
              >
                {{ estadoGeneralMesaPorProductos() }}
              </span>
            </div>
          </div>

          <div>
            <label class="text-xs font-semibold uppercase text-slate-500">
              Tiempo Transcurrido
            </label>
            <p class="text-lg font-bold text-slate-900">{{ calcularTiempoTranscurrido() }}</p>
          </div>

          <div class="rounded-lg bg-slate-50 p-3">
            <div class="flex items-center justify-between gap-3">
              <span class="font-semibold text-slate-900">Total</span>
              <span class="text-xl font-bold text-blue-600">{{
                calcularPrecioTotal() | currency: 'PEN' : 'S/. '
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Barra de acciones: fija al fondo en mobile/tablet, integrada en desktop -->
  <div
    class="sticky bottom-0 z-20 -mx-4 border-t border-slate-200 bg-white/95 px-4 py-3 backdrop-blur sm:-mx-6 sm:px-6 lg:static lg:mx-0 lg:rounded-xl lg:border lg:px-5 lg:shadow-sm"
  >
    <div class="flex flex-col gap-2.5 sm:flex-row sm:items-center sm:gap-3">
      <div
        class="flex items-center justify-between gap-3 sm:mr-auto sm:justify-start sm:gap-2"
      >
        <span class="text-xs font-semibold uppercase tracking-wide text-slate-500">Total</span>
        <span class="text-lg font-bold text-blue-600">{{
          calcularPrecioTotal() | currency: 'PEN' : 'S/. '
        }}</span>
      </div>

      <div class="grid grid-cols-2 gap-2 sm:flex sm:items-center sm:gap-3">
        <!-- boton para imprimir con opciones -->
        <app-split-button
          class="col-span-2 w-full sm:col-span-1 sm:w-auto"
          label="Imprimir"
          icon="bi bi-printer"
          variant="success"
          [options]="opcionesImpresion"
          (onClick)="imprimirComanda()"
        />

        <button
          class="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-3 text-sm font-semibold text-white shadow-md transition duration-200 hover:bg-blue-700 sm:flex-1"
          (click)="vender()"
          type="button"
          aria-label="Procesar venta"
        >
          <i class="bi bi-cart-check-fill" aria-hidden="true"></i>
          <span>Vender</span>
        </button>

        <button
          class="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-slate-600 px-4 py-3 text-sm font-semibold text-white shadow-md transition duration-200 hover:bg-slate-700 sm:flex-1"
          (click)="cerrar.emit()"
          type="button"
          aria-label="Cerrar comanda"
        >
          <i class="bi bi-x-circle-fill" aria-hidden="true"></i>
          <span>Cerrar</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-dialog
  header="Agregar Producto a la Comanda"
  [(visible)]="modal_agregar_producto"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  size="7xl"
  styleClass="w-[92vw] max-w-[1100px]"
  (onHide)="modal_agregar_producto.set(false)"
>
  @if (modal_agregar_producto()) {
    <app-agregar-producto-venta
      (agregar_productos)="handleAgregarProductos($event)"
      (cerrar)="modal_agregar_producto.set(false)"
    />
  }
</app-dialog>
<app-dialog
  header="Confirmar Entrega de Todos los Productos"
  [(visible)]="modal_confirmar_entregar_todos"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  size="xs"
  (onHide)="modal_confirmar_entregar_todos.set(false)"
>
  <app-modal-confirmacion
    mensaje="¿Estás seguro que deseas entregar todos los productos?"
    textoCancel="Cancelar"
    textoConfirm="Si"
    (confirmar)="entregarTodos()"
    (cancelar)="modal_confirmar_entregar_todos.set(false)"
  />
</app-dialog>
<app-dialog
  header="Confirmar Limpieza de Productos"
  [(visible)]="modal_confirmar_limpiar_productos"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  size="xs"
  (onHide)="modal_confirmar_limpiar_productos.set(false)"
>
  <app-modal-confirmacion
    mensaje="¿Estás seguro que deseas limpiar todos los productos?<br>Esta acción no se puede deshacer."
    textoCancel="Cancelar"
    textoConfirm="Si"
    (confirmar)="limpiarProductos()"
    (cancelar)="modal_confirmar_limpiar_productos.set(false)"
  />
</app-dialog>
<app-dialog
  header="Procesar Pago"
  [(visible)]="modal_procesar_pago"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  size="4xl"
  (onHide)="modal_procesar_pago.set(false)"
>
  @if (modal_procesar_pago()) {
    <app-procesar-venta
      (closedModal)="modal_procesar_pago.set(false)"
      [mesaId]="$safeNavigationMigration(mesa()?.id)"
    />
  }
</app-dialog>
<app-dialog
  header="Editar Mesa"
  [(visible)]="modal_editar_mesa"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  size="sm"
  (onHide)="modal_editar_mesa.set(false)"
>
  <app-agregar-mesa [mesaEditar]="mesa() || undefined" (cerrar)="modal_editar_mesa.set(false)" />
</app-dialog>
